import $ from "jquery"

import BasePage from "pages/base_page"

const podcastsPageEvents = { "change #podcast-sort": "changeSort" }

class PodcastsPage extends BasePage {
  get events() {
    return podcastsPageEvents
  }

  initialize(options) {
    return super.initialize(options)
  }

  changeSort() {
    const val = $("#podcast-sort").val()
    const url = `${document.location.pathname}?sort=${val}`

    return (document.location.href = url)
  }
}

export default PodcastsPage
